import React from 'react';
// import { Link } from 'react-router';
// import ReactDOM from 'react-dom';
// import jQuery from 'jquery';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import * as SVGICONS from '../../images/img/images';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
	Modal,
} from 'react-bootstrap';
// import classNames from 'classnames';
import * as signinActions from '../../actions/signinActions';
// import validator from './../common/validator.js';
const autoBind = require('auto-bind');


class UnsubscribeEmails extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			isUnLocked: true
		};
		//binding current context to all functions
	}
	componentWillMount() {
        // debugger;
		let obj = {
			key: this.props.unSubscribekey
		}
		this.props.actions.unSubscribe(obj);
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.unSubscribe.success) {
			this.setState({ isUnSubscribe: true })
		} else {
			this.setState({ isUnSubscribe: false })
		}
	}

	render() {

		return (
			<Modal show={this.props.unSubscribeEmails} size="modal-sm" onHide={this.props.closeunSubscribeEmails}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.closeunSubscribeEmails} /> */}
					<img src={require('../../images/images/logo.svg')} alt="" />
				</Modal.Header>
				<Modal.Body>
					{/* <ToastContainer /> */}
					<form className="signup-form" id="loginForm">
						<div className="signIn changePass">{this.state.isUnSubscribe ? 'Unsubscribe Emails' : ''}</div>
						<p style={{ "textAlign": "center" }}>{this.state.isUnSubscribe ? 'Emails have been Unsubscribed successfully' : 'Emails Already Unsubscribed'}</p>

						{/* <div className="loginInput">
							<div className="btngrouplogIn ">
								<Link to="" onClick={this.props.closeUnLockAccountOpenSigin} className="forgetPass"> Go to Sign In</Link>
							</div>

						</div> */}
					</form>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
	return {
		// unSubscribe: state.signin.unSubscribe
	};
}

// bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(signinActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(UnsubscribeEmails);
// export default (Signup);


